import type { IDropdownItemOptions } from '../../Dropdown.helpers';
import { DefaultInputValue } from '../input-value/Default';

const DefaultItemOptions = ({ items, hideValue, iconAs, handleItemSelection, CustomItemOption }: IDropdownItemOptions) => (
	<>
		{items.map((item) => (
			<button
				type='button'
				key={`${item.code}_${item.name}`}
				onClick={handleItemSelection(item)}
				className='dropdown_content_item_options_item'
				data-testid={`country-button-${item.code}`}
				title={item.name}
				name={item.name}
			>
				{!CustomItemOption ? (
					<>
						<span className='dropdown_content_item_options_item_name'>{item.name}</span>

						{!hideValue && <span className='dropdown_content_item_options_item_code'>{item.value}</span>}
						<span className='dropdown_content_item_options_item_flag'>
							<DefaultInputValue
								icon={item.icon}
								iconAs={iconAs}
							/>
						</span>
					</>
				) : (
					<CustomItemOption item={item} />
				)}
			</button>
		))}
	</>
);

export default DefaultItemOptions;
